module.exports = __webpack_public_path__ + "static/logo-prezidentas-6b3e50216f4829593cc7cd7c231f263f.svg";